<template>
  <div class="home">
  
    <Reproductor msg="Lugar de origen" audio2="../mp3/PrimariaE/01PE.mp3" cover="../img/5.jpg" name="Primaria E - Lección #1"/>
    <Buttons/>
  </div>
</template>

<script>
// @ is an alias to /src

import Buttons from '@/components/Buttons.vue'
import Reproductor from '@/components/Reproductor.vue'
export default {
  name: 'LeccionA1',

  components: {
    Reproductor,
    Buttons,
    
  }
}
</script>
